export default () =>
  import(/* webpackChunkName: 'coffee/activities/luckincard/home' */ './Home');
